import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "./ApiRequest";
import { AuthFlow, CicConfig, UserFlow } from "./EndPoints";
// Auth flow
export const loginApi = (payload) => {
  return postRequest(AuthFlow.LOGIN, payload);
};
export const RegisterApi = (payload) => {
  return postRequest(AuthFlow.REGISTER, payload);
};
export const ForgotPasswordApi = (payload) => {
  return postRequest(AuthFlow.FORGET_PASSWORD, payload);
};
export const ResetPasswordApi = (payload) => {
  return postRequest(AuthFlow.RESET_PASSWORD, payload);
};
export const ResetPasswordConfirm = (userId, token) => {
  return getRequest(`${AuthFlow.CONFIRM_TOKEN}/${userId}/${token}`);
};
// user flow

export const GetUserAPI = () => {
  return getRequest(UserFlow.USER);
};
export const editUserAPI = (payload) => {
  return patchRequest(UserFlow.USER, payload);
};
export const DeleteUserAPI = () => {
  return deleteRequest(UserFlow.USER);
};

export const GetUsersAdminAPI = (
  currentPage,
  pageSize,
  query = "",
  order = "",
  role = ""
) => {
  return getRequest(
    `${UserFlow.USER_ADMIN}?page=${currentPage}&per_page=${pageSize}&query=${query}&order=${order}&role=${role}`
  );
};
export const CreateUsersAdminAPI = (payload) => {
  return postRequest(UserFlow.USER_ADMIN, payload);
};
export const UpdateUserAdminAPI = (id, payload) => {
  return patchRequest(`${UserFlow.USER_ADMIN}/${id}`, payload);
};
export const DeleteUsersAdminAPI = (id) => {
  return deleteRequest(`${UserFlow.USER_ADMIN}/${id}`);
};

export const GetUsersResellerAPI = (
  currentPage,
  pageSize,
  query = "",
  order = ""
) => {
  return getRequest(
    `${UserFlow.USER_RESELLER}?page=${currentPage}&per_page=${pageSize}&query=${query}&order=${order}`
  );
};
export const GetResellerAPI = (currentPage, pageSize, query = "") => {
  return getRequest(
    `${UserFlow.RESELLER}?page=${currentPage}&per_page=${pageSize}&query=${query}`
  );
};
export const UpdateUserResellerAPI = (id, payload) => {
  return patchRequest(`${UserFlow.USER_RESELLER}/${id}`, payload);
};

export const DeleteUsersResellerAPI = (id) => {
  return deleteRequest(`${UserFlow.USER_RESELLER}/${id}`);
};
// UsersResellerAPI

export const CreateUsersResellerAPI = (payload) => {
  return postRequest(UserFlow.USER_RESELLER, payload);
};

// import product cassa cloud
export const GetSectionsApi = () => {
  return getRequest(CicConfig.SECTION);
};
export const AddCicApi = (payload) => {
  return postRequest(CicConfig.API, payload);
};
export const GetCicApi = () => {
  return getRequest(CicConfig.API);
};
export const UpdateCicApi = (payload) => {
  return patchRequest(CicConfig.API, payload);
};
export const DeleteCicApi = () => {
  return deleteRequest(CicConfig.API);
};
export const GetCategories = (currentPage, pageSize) => {
  return getRequest(
    `${
      CicConfig.CATEGORIES
    }?query=${"cache"}&page=${currentPage}&per_page=${pageSize}`
  );
};
export const ImportCicProductsApi = (payload) => {
  return postRequest(CicConfig.PRODUCTS_CIC, payload);
};

// Ordine delle voci del menu a sinistra, per cliente.
export const SaveMenuOrderAPI = (menuOrder) =>
  putRequest("user/menu-order", { menu_order: menuOrder });

// Suggerimento AI della sezione della carta per ogni categoria della cassa.
export const SuggestCategorySectionsAPI = () => {
  return postRequest(`${CicConfig.CATEGORIES}/suggest`, {});
};

// Chiave dell'AI (solo super admin): la chiave non torna mai indietro, solo mascherata.
export const GetAIKeyAPI = () => getRequest("user/ai-key");
export const SaveAIKeyAPI = (apiKey) => putRequest("user/ai-key", { api_key: apiKey });
export const DeleteAIKeyAPI = () => deleteRequest("user/ai-key");
export const TestAIKeyAPI = () => postRequest("user/ai-key/test", {});

// Istruzioni di ricerca dell'AI (solo super admin).
export const GetAIPromptAPI = () => getRequest("user/ai-prompt");
export const SaveAIPromptAPI = (prompt) => putRequest("user/ai-prompt", { prompt });
export const ResetAIPromptAPI = () => deleteRequest("user/ai-prompt");
